module.exports = __webpack_public_path__ + "media/images/participant-audio-active-6434ed32335b886454d674bce56226fc.svg";